import React, { useState, useEffect } from 'react';
import { User } from 'lucide-react';
import { characterImageUrls } from '../utils/mediaUrls';

/**
 * Character portrait — family images at images/family/{Name}.jpeg,
 * with optional fallback to images/Characters/{Name}.jpg.
 */
const CharacterImage = ({
  name,
  sourceName,
  alt = '',
  className = '',
  fallbackClassName = '',
  fallbackEmoji = null,
  iconClassName = 'w-5 h-5 text-gita-maroon'
}) => {
  const candidates = characterImageUrls(name, sourceName);

  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [name, sourceName]);

  const src = candidates[index];
  const failed = !candidates.length || index >= candidates.length;

  if (!src || failed) {
    if (fallbackEmoji) {
      return (
        <div className={fallbackClassName || className} aria-hidden={!alt}>
          {fallbackEmoji}
        </div>
      );
    }

    return (
      <div
        className={`character-image-fallback bg-gita-saffron flex items-center justify-center shrink-0 ${fallbackClassName || className}`}
        aria-hidden={!alt}
      >
        <User className={iconClassName} />
      </div>
    );
  }

  return (
    <img
      key={src}
      src={src}
      alt={alt || name || ''}
      className={`character-image object-cover object-top shrink-0 ${className}`}
      loading="lazy"
      onError={() => setIndex((i) => i + 1)}
    />
  );
};

export default CharacterImage;
